import Vue from 'vue';

const frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  userInfo: null,
  diamondBankList: null, //- 鑽保銀行
  sliverBankList: null,  //- 銀保銀行
  pendingMessage: null,  //- 綁定審核文字
};

// getters
const getters = {};

// actions
const actions = {
  checkApply({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/check-apply`)
      .then( res => {
        commit('setApplyRes', res.data);
      });
  },
  update({commit}, data) {
    return Vue.prototype.$frontendAxios.post(`${frontendApiUrl}/apply-update`, data)
      .then( res => {
        return res;
      })
      .catch( err => {
        return err;
      });
  },
  checkIsPending({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/bind/is-pending`, {
      params: data
    })
      .then( res => {
        commit('setPendingMessage', res.data.message);
        return res;
      })
      .catch( err => {
        return err;
      });
  },
  getMemberInfo({commit}, data) {
    return Vue.prototype.$frontendAxios.get(`${frontendApiUrl}/member-info`, {
      params: data
    })
      .then( res => {
        commit('setMemberInfo', res.data.data);
        return res;
      })
      .catch( err => {
        return err;
      });
  },

};

// mutations
const mutations = {
  setApplyRes(state, data) {
    Vue.set(state, 'applyRes', data);
  },
  setPendingMessage(state, data) {
    Vue.set(state, 'pendingMessage', data);
  },
  setMemberInfo(state, data) {
    console.log(data)
    Vue.set(state, 'memberInfo', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
